<canvas #canvas class="canvas chart-canvas" [ngClass]="{
'canvas_opacity__on': isCanvasVisible(),
'canvas_opacity__off': !isCanvasVisible()
}"></canvas>
<app-simple-mat-tooltip #tooltip [autoHideTimeout]="tooltipAutoHideTimeout"></app-simple-mat-tooltip>




